import React from 'react';
import {
  useState,
} from 'react';
import {
  Modal,
  Text,
  Banner,
} from '@shopify/polaris';
import TagListComponent from '../../components/TagListComponent';

function AddTagsDialog(props) {

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagClick =
    (tag) => {

      var newSelected = [...selectedTags, tag];
      setSelectedTags(newSelected);
    };

  const handleTagRemove =
    (tag) => {
      var index = selectedTags.indexOf(tag);

      if (index !== -1) {
        var newSelected = [
          ...selectedTags.slice(0, index),
          ...selectedTags.slice(index + 1)
        ];
        setSelectedTags(newSelected);
      }
    };

  const handleActionOnNoMatchingTags =
    (query) => {

      var newSelected = [...selectedTags, query];
      setSelectedTags(newSelected);

      return true;
    };

  const searchableTags = props.tags.filter(_ => !selectedTags.includes(_));

  return (<div>
    <Modal
      large
      fullScreen
      instant
      open={props.active}
      onClose={props.onCancel}
      title="Add Tags"
      primaryAction={{
        content: props.executing ? 'Creating operation, please wait...' : 'Execute',
        loading: props.executing,
        onAction: () => props.onExecute(selectedTags),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: props.onCancel,
          disabled: props.executing
        },
      ]}
    >
      <Modal.Section title="Tags To Add" titleHidden={false}>
        <Text variant="bodyLg" as="h1">
          Tags To Add
        </Text>
        <br />

        {selectedTags.length === 0 && <Banner status='warning'>Please select at least one tag from the list below or enter a new tag name.</Banner>}

        <TagListComponent
          enableSearch={false}
          tags={selectedTags}
          tagDisplayState="added"
          onTagRemove={handleTagRemove}
        />

      </Modal.Section>
      <Modal.Section title="All Available Tags">
        <Text variant="bodyLg" as="h1">
          All Available Tags
        </Text>
        <br />
        <TagListComponent
          searchBoxPlaceholder="Search to find or create tags"
          tags={searchableTags}
          enableSearch
          actionOnNoMatching={handleActionOnNoMatchingTags}
          onTagClick={handleTagClick} />
      </Modal.Section>
    </Modal>
  </div>);
}

export default AddTagsDialog;